/**
 * @fileoverview Logging utility functions for Custom Mosaics.
 *
 * Provides development-only logging that is automatically suppressed in production
 * unless VITE_ENABLE_DEBUG_LOGS is set to "true" (e.g., for staging/preview builds).
 *
 * @module logger
 *
 * @example
 * import { log, error as logError } from '../utils/logger';
 *
 * log('This is a log message');
 * log('Message with data', { foo: 'bar' });
 * logError('This is an error message');
 */

const isLoggingEnabled = !import.meta.env.PROD || import.meta.env.VITE_ENABLE_DEBUG_LOGS === 'true';

/**
 * Log a message to the console (development or when VITE_ENABLE_DEBUG_LOGS is set).
 * @param {string} message - The message to log
 * @param {*} [data=null] - Optional data to log with the message
 */
export function log(message, data = null) {
    if (isLoggingEnabled) {
        if (data != null) {
            console.log(message, data);
        } else {
            console.log(message);
        }
    }
}

/**
 * Log an error message to the console (development or when VITE_ENABLE_DEBUG_LOGS is set).
 * @param {string} message - The error message to log
 * @param {*} [data=null] - Optional data to log with the error
 */
export function error(message, data = null) {
    if (isLoggingEnabled) {
        if (data != null) {
            console.error(message, data);
        } else {
            console.error(message);
        }
    }
}
